// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2yf_f","header":"MergedInvoice_header__2olQI"};